export const C_KMS = 299792.458;

// MJD 51544.5 == 2000-01-01 00:00 UTC; 365.25 days per mean Julian year.
export const MJD_AT_YEAR_2000 = 51544.5;
export const DAYS_PER_YEAR = 365.25;

export function yearToMjd(year: number): number {
  return MJD_AT_YEAR_2000 + (year - 2000) * DAYS_PER_YEAR;
}

/** Fractional calendar year; callers round when they want a label. */
export function mjdToYear(mjd: number): number {
  return 2000 + (mjd - MJD_AT_YEAR_2000) / DAYS_PER_YEAR;
}
